import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostChangeLetter = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_CHANGE_LETTER_CASHIERS
            });
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostChangeLetter as SetPostChangeLetter
}